<script setup lang="ts">
import { } from 'vue'
import { VuePDF, usePDF } from '@tato30/vue-pdf'

//also used to display invoice pdf

const props = withDefaults(defineProps<{
  filePath: string
  scale?: number
}>(), {
  scale: 1
})

const { pdf, pages } = usePDF(props.filePath)
</script>

<template>
  <div v-for="page in pages" :key="page">
    <VuePDF :scale="scale" :pdf="pdf" :page="page"  class="rounded-lg" />
  </div>
</template>
